import { oc } from '@orpc/contract';
import { GovProcedureTypeSchema } from '@standandforce/api-contract';
import { z } from 'zod';

/**
 * Labor Core パターン起動（targets + selectedGovProcedureTypes）。
 * Backend: start-operation-package-pattern.dto.ts
 * TODO: `@standandforce/api-contract` に publish されたら import へ差し替え。
 */

const PersonStartTargetSchema = z.object({
  targetPersonId: z.string(),
  /**
   * 実施する行政手続き（GovProcedureType）。
   * 省略時はその対象者はパターン内の全手続を実施。空配列は不可（422）。
   */
  selectedGovProcedureTypes: z.array(GovProcedureTypeSchema).optional()
});
const StartLaborCoreOperationPackagePatternInputSchema = z.object({
  id: z.string(),
  patternId: z.string(),
  anchorDate: z.string(),
  tagName: z.string().optional(),
  /**
   * 対象者ごとの起動指定。指定時は targetPersonIds より優先。
   * targetPersonIds との同時指定は不可（422）。
   */
  targets: z.array(PersonStartTargetSchema).min(1)
});
const StartLaborCoreOperationPackagePatternOutputSchema = z.object({
  results: z.array(z.object({
    targetPersonId: z.string().optional(),
    targetContractId: z.string().optional(),
    operationPackageInstanceId: z.string()
  }))
});
export const startLaborCoreOperationPackagePatternContract = oc.route({
  method: 'POST',
  path: '/v2/labor-core/operation-packages/{id}/patterns/{patternId}'
}).input(StartLaborCoreOperationPackagePatternInputSchema).output(StartLaborCoreOperationPackagePatternOutputSchema);
export type StartLaborCoreOperationPackagePatternInput = z.infer<typeof StartLaborCoreOperationPackagePatternInputSchema>;
export type StartLaborCoreOperationPackagePatternOutput = z.infer<typeof StartLaborCoreOperationPackagePatternOutputSchema>;